import cx from 'classnames';
import { RiskScoreLevelEnum } from '@/api';

import styles from './RiskIndicatorBar.module.sass';

export interface RiskIndicatorBarProps {
  risk: RiskScoreLevelEnum | null;
  className?: string;
}

const RiskIndicatorBar = ({ risk, className }: RiskIndicatorBarProps) => {
  const classes = cx(
    styles.bar,
    {
      [styles[`bar--${risk}`]]: risk,
    },
    className,
  );

  return (
    <svg
      viewBox="0 0 176 89"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={classes}
    >
      <path
        d="M2.93418032,88.0000073 C1.28669032,88.0000073 -0.0541492214,86.6640073 0.00168271855,85.0174073 C0.481953319,70.8531073 4.37732032,56.9982073 11.3749303,44.6400073 C18.3726303,32.2818073 28.2496303,21.8139073 40.1488303,14.1154073 C41.5320303,13.2204073 43.3675303,13.6829073 44.2150303,15.0957073 L51.1054303,26.5813073 C51.9529303,27.9941073 51.4906303,29.8210073 50.1159303,30.7291073 C41.0798303,36.6987073 33.5718303,44.7306073 28.2217303,54.1792073 C22.8716303,63.6278073 19.8464303,74.1980073 19.3759303,85.0177073 C19.3043303,86.6637073 17.9755303,88.0000073 16.3281303,88.0000073 L2.93418032,88.0000073 Z"
        className={styles.first}
      />

      <path
        d="M46.0912303,14.0025073 C45.2800303,12.5686073 45.7826303,10.7437073 47.2433303,9.98158734 C59.8081303,3.42551734 73.7852303,-0.00579100354 87.9871303,-1.77635684e-15 C102.18913,0.00582093646 116.16313,3.44853734 128.72313,10.0149073 C130.18313,10.7782073 130.68413,12.6035073 129.87113,14.0368073 L123.26713,25.6892073 C122.45513,27.1225073 120.63713,27.6196073 119.17013,26.8703073 C109.52513,21.9446073 98.8373303,19.3644073 87.9792303,19.3600073 C77.1210303,19.3556073 66.4313303,21.9270073 56.7823303,26.8448073 C55.3145303,27.5929073 53.4971303,27.0943073 52.6859303,25.6604073 L46.0912303,14.0025073 Z"
        className={styles.second}
      />

      <path
        d="M131.70413,15.1058073 C132.55213,13.6932073 134.38713,13.2311073 135.77013,14.1264073 C147.66813,21.8276073 157.54213,32.2978073 164.53713,44.6576073 C171.53213,57.0174073 175.42413,70.8732073 175.90113,85.0377073 C175.95713,86.6842073 174.61513,88.0196074 172.96813,88.0196074 L159.57413,88.0165073 C157.92713,88.0161073 156.59813,86.6795073 156.52713,85.0335073 C156.05913,74.2137073 153.03613,63.6428073 147.68813,54.1929073 C142.34013,44.7431073 134.83413,36.7095073 125.79913,30.7378073 C124.42513,29.8294073 123.96313,28.0024073 124.81113,26.5898073 L131.70413,15.1058073 Z"
        className={styles.third}
      />
    </svg>
  );
};

export default RiskIndicatorBar;
